import * as types from '../mutation-types'
import { restApiRequest, getErrorMessage } from './ajax'

const digestive = {
  namespaced: true,
  state: {
    report: {}
  },
  getters: {
    billingList: state => (state.report ? state.report.billingList : []),
    total: state => (state.report ? state.report.total : {})
  },
  mutations: {
    [types.RECEIVE_SETDIGESTIVE](state, report) {
      state.report = report
    }
  },
  actions: {
    /**
     * 請求情報を取得する
     * @param {*} params
     */
    getReport: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const yyyymm = params.yyyymm
        const agencyId = params.agencyId
        const advertiserId = params.advertiserId === 'undefined' ? '0' : params.advertiserId
        // 初期リリースでは広告主は固定
        restApiRequest(baseURL, `/api/billing/list/${params.privateCode}/${agencyId}/${advertiserId}/${yyyymm}`, params.jwtToken)
          .then(result => {
            if (result.status === 200) {
              const report = parse(result)
              commit(types.RECEIVE_SETDIGESTIVE, report)
              resolve(report)
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_SETDIGESTIVE, undefined)
    }
  }
}
function parse(response) {
  return response.data
}
export default digestive
